export default __webpack_public_path__ + "static/media/walks.103cca91.svg";